import { z } from "zod";

export const romFlowsheetFormSchema = z.object({
  examDate: z.date().nullable(),
  examTime: z.string().nullable(),
  method: z.string().nullable().optional(),
  confirmedBy: z.string().nullable().optional(),
  confirmedByOther: z.string().optional(),
  fluidColor: z.string().nullable().optional(),
  fluidColorOther: z.string().optional(),
  notes: z.string().optional(),
  signatureInitials: z.array(z.string()).optional(),
});

export type RomFlowsheetFormSchemaType = z.infer<typeof romFlowsheetFormSchema>;
